import { render } from "./ProposalNoArguments.vue?vue&type=template&id=3f5e7546&scoped=true"
import script from "./ProposalNoArguments.vue?vue&type=script&lang=js"
export * from "./ProposalNoArguments.vue?vue&type=script&lang=js"

import "./ProposalNoArguments.vue?vue&type=style&index=0&id=3f5e7546&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f5e7546"]])

export default __exports__